/** @jsx h */
import { h, Component, JSX } from 'preact';
import cssStyles from './arrow-button.css';
import Arrow from './arrow';

interface ArrowButtonProps {
  size: number;
  color: string;
}

export class ArrowButton extends Component<ArrowButtonProps> {
  render(): JSX.Element {
    const { size, color } = this.props;
    const arrowSize = size / 3.33;

    const buttonStyle = {
      width: `${size}px`,
      height: `${size}px`,
      borderColor: color
    };

    return (
      <div className={cssStyles.button} style={buttonStyle}>
        <Arrow size={arrowSize} color={color} />
        <Arrow size={arrowSize} color={color} />
      </div>
    );
  }
}
